var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProviderSendInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5735aa;}.cls-2{fill:#bfebff;}.cls-3{fill:#71c2ea;}.cls-4{fill:#fff;}.cls-5{fill:#febe10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_send_invite"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.62.35h0L.23,140,90,467.35l.08.27L599.46,328l-.07-.28L509.64.35ZM324.7,226.9l-.3.37h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "556.29 69.45 556.29 399.27 43.4 399.27 43.4 69.74 299.8 251.96 556.25 69.7 556.25 69.41 556.29 69.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M556.29,399v.27H43.4V399L274.06,235.06a44.52,44.52,0,0,1,51.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M556.29,69.71v-.28H43.4v.28L274.06,233.65a44.52,44.52,0,0,0,51.57,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 459.96,
    cy: 459.59,
    r: 139.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.31,423.76h61.85a0,0,0,0,1,0,0v70.9a0,0,0,0,1,0,0H401.31a35.45,35.45,0,0,1-35.45-35.45v0A35.45,35.45,0,0,1,401.31,423.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M551,450.51l-68.24-77.68a12.24,12.24,0,0,0-21.44,8.08V536.26a12.24,12.24,0,0,0,21.44,8.09L551,466.67A12.24,12.24,0,0,0,551,450.51Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderSendInvite);
export default __webpack_public_path__ + "static/media/provider_send_invite.b0edba0be1f238403c75b0bbdc283351.svg";
export { ForwardRef as ReactComponent };